/**
 * Атрибуты куки `sv_contour` — от домена ТЕКУЩЕГО хоста, а не зашитого.
 *
 * Родительский домен даёт одну куку кабинету, админке и их `beta-*`
 * поддоменам. Он был зашит как `.sam-vision.uz`, а кабинет открывается и на
 * `cabinet.samvision.uz` (домен сайта, 2026-09-30): там браузер молча
 * отвергает куку чужого домена, и пользователь беты получал бы данные релиза.
 * Домены платформы двухуровневые (`sam-vision.uz`, `samvision.uz`), поэтому
 * родитель — последние две метки. localhost / IP — кука хоста, без Domain.
 * Та же правка, что в админке (samvision_admin 28e76d2).
 */
export function contourCookieAttrs(hostname: string): string {
  const labels = hostname.split('.');
  const bare =
    hostname === 'localhost' ||
    /^[\d.]+$/.test(hostname) ||
    hostname.includes(':') ||
    labels.length < 2;
  const domain = bare ? '' : `Domain=.${labels.slice(-2).join('.')}; `;
  return `${domain}Path=/; SameSite=Lax`;
}
